import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Footer = () => {
    return (
        <div className="b-t spacer">
            <Container>
                <div className="f4-bottom-bar">
                    <Row>
                        <Col md="12 text-center">
                            <div className="d-flex font-16">
                                <div className="m-t-1 m-b-1 copyright">All Rights Reserved by Convext</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
}
export default Footer;
